export const enum DrawingToolsType {
    CurvedLine = 'curvedLine', 
    Crooked3 = 'crooked3',
    Crooked5 = 'crooked5',
    NewTextBox = 'customLabel',
    Segment = 'segment',
    ArrowSegment = 'arrowSegment',
    Ray = 'ray',
    ArrowRay = 'arrowRay',
    Line = 'infinityLine',
    ArrowLine = 'arrowInfinityLine',
    HorizontaLine = 'horizontalLine',
    VerticalLine = 'verticalLine',
    Elliott3 = 'elliott3',
    Elliott5 = 'elliott5',
    
    VerticalCounter = 'verticalCounter',
    VerticalLabel = 'verticalLabel',
    VerticalArrow = 'verticalArrow',
    
    Fibonacci = 'fibonacci',
    FibonacciTimezones = 'fibonacciTimeZones',
    Pitchfork = 'pitchfork',
    ParallelChannel = 'parallelChannel',
    TimeCycles = 'timeCycles',

    Measure = 'measure',

    Flags = 'flags',
    
    Emoji = 'emoji'
}
